import "./camera.scss";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import m from "mithril";
import {Icon, Icons, Overlay} from "../old/tools/constructui";
// import {ImageCapture} from "image-capture";
import workermanager from "../old/worker-manager";
//import {max} from "moment/moment";
import pf from "../old/pf";
import lf from "localforage";
import {ulid} from "ulid";

// import cameracomp from "camera-component";
// import {applyPolyfills, defineCustomElements} from "camera-component/loader";

export default () => {
	let localImageStore = lf.createInstance("localimagestore");
	let prasorasettings = lf.createInstance("prasorasettings");

	let state = {
		errorinfo: undefined,
		showexplorer: false,
		images: [],
		imageindex: -1,
		width: 320,
		shouldFaceUser: true,
		drawlinewidth: 2,
		drawlinecolor: "black",
	};

	async function SaveStateToLocal() {
		console.log("saving state");
		if (state.images && state.images.length > 0) localImageStore.setItem(state.nf, state.images);
		else localImageStore.removeItem(state.nf);
		prasorasettings.setItem("camera_drawlinewidth", state.drawlinewidth);
		prasorasettings.setItem("camera_drawlinecp;pr", state.drawlinecolor);
	}

	async function SeeIfPendingState() {
		console.log("restoring state");
		let images = await localImageStore.getItem(state.nf);
		if (images) state.images = images;
		prasorasettings.getItem("camera_drawlinewidth").then((val) => {
			state.drawlinewidth = state.drawlinewidth || val;
		});
		prasorasettings.getItem("camera_drawlinecolor").then((val) => {
			state.drawlinecolor = state.drawlinecolor || val;
		});
	}

	function ClearFiles() {
		state.images = [];
		SaveStateToLocal();
	}

	async function OnFileUpload(e) {
		const input = e.target;

		for (var i = 0; i < input.files.length; i++) {
			await new Promise((resolve) => {
				var reader = new FileReader();
				reader.onload = function (r) {
					let url = r.target.result;
					let compressURL = CompressImage(url).then((compressedfile) => {
						resolve();
						state.images.push({
							seq: i,
							url: compressedfile,
							original: url,
							name: input.files[i].name,
							modifiers: {},
						});
						SaveStateToLocal();
						m.redraw();
						resolve();
					});
				};
				reader.readAsDataURL(input.files[i]);
			});
		}

		console.log({inputfiles: input.files, outputfiles: state.images});
	}

	const ChangeOptions = {
		FlipH: "FlipH",
		FlipV: "FlipV",
		RotateCW: "RotateCW",
		RotateCCW: "RotateCCW",
		ZoomIn: "ZoomIn",
		ZoomOut: "ZoomOut",
		MoveLeft: "MoveLeft",
		MoveRight: "MoveRight",
		MoveUp: "MoveUp",
		MoveDown: "MoveDown",
	};

	function PerformChange(change) {
		switch (change) {
			case ChangeOptions.RotateCCW:
				{
					state.images[state.imageindex].modifiers.Angle = (state.images[state.imageindex].modifiers.Angle || 0) - 90;
					if (state.images[state.imageindex].modifiers.Angle < 0)
						state.images[state.imageindex].modifiers.Angle = 360 + state.images[state.imageindex].modifiers.Angle;
				}
				break;
			case ChangeOptions.RotateCW:
				{
					state.images[state.imageindex].modifiers.Angle = (state.images[state.imageindex].modifiers.Angle || 0) + 90;
					if (state.images[state.imageindex].modifiers.Angle == 360)
						state.images[state.imageindex].modifiers.Angle == 0;
				}
				break;
		}
		DrawImage();
		SaveStateToLocal();
	}

	async function CompressImage(url) {
		console.log("compressing");
		return new Promise((resolve) => {
			if (state.hiddencanvas) {
				let img = new Image();
				img.onload = function () {
					let context = state.hiddencanvas.getContext("2d");

					context.clearRect(0, 0, state.hiddencanvas.width, state.hiddencanvas.height);
					context.save();

					context.fillStyle = "white";
					context.fillRect(0, 0, state.hiddencanvas.width, state.hiddencanvas.height);

					// context.translate(state.hiddencanvas.width / 2, state.hiddencanvas.height / 2);
					let imgH = img.height;
					let imgW = img.width;

					let scale = Math.min(state.hiddencanvas.width, state.hiddencanvas.height) / Math.max(imgH, imgW); // myimg.modifiers.Zoom;

					let cW = scale * imgW;
					let cH = scale * imgH;

					let l = (state.hiddencanvas.width - cW) / 2;
					let h = (state.hiddencanvas.height - cH) / 2;

					//let l = (imgMax - imgW)/;
					//let t = -state.hiddencanvas.height / 2;

					// let left = (imgMax - imgW) / 2; //(imgW - imgMin) / 2;
					// let top = (imgMax - imgH) / 2;

					context.drawImage(img, 0, 0, imgW, imgH, l, h, cW, cH);
					context.restore();
					console.log("resolving compressed");

					resolve(state.hiddencanvas.toDataURL("image/jpeg"));
				};
				img.src = url;
			}
		});
	}

	function DrawImage() {
		if (state.preview) {
			let myimg = state.images[state.imageindex];
			let context = state.preview.getContext("2d");

			context.clearRect(0, 0, state.preview.width, state.preview.height);
			context.save();

			context.translate(state.preview.width / 2, state.preview.height / 2);
			let l = -state.preview.width / 2;
			let t = -state.preview.height / 2;

			let scale = 1; // myimg.modifiers.Zoom;

			context.scale(myimg.modifiers.flipH ? -1 * scale : 1 * scale, myimg.modifiers.flipV ? -1 * scale : 1 * scale);

			if (myimg.modifiers.Angle) {
				if (myimg.modifiers.Angle > 0) {
					context.rotate((myimg.modifiers.Angle * Math.PI) / 180);
				}
			}

			let img = new Image();
			img.onload = function () {
				let imgH = img.height;
				let imgW = img.width;

				let imgMin = Math.min(imgH, imgW);
				let left = (imgW - imgMin) / 2;
				let top = (imgH - imgMin) / 2;

				context.drawImage(img, left, top, imgMin, imgMin, l, t, state.preview.width, state.preview.height);

				if (!state.images[state.imageindex].compressed) {
					state.images[state.imageindex].compressed = true;
					state.images[state.imageindex].url = state.preview.toDataURL("image/jpeg");
				}
				context.restore();
				state.context = context;
			};
			img.src = myimg.url;
		}
	}

	function startdraw(e) {
		if (state.drawmode) {
			// console.log("started");
			state.context = state.preview.getContext("2d");

			state.isDrawing = true;
			state.rect = state.preview.getBoundingClientRect();

			SetXY(e);
			state.context.moveTo(state.x, state.y);
			state.context.beginPath();
			state.context.lineWidth = state.drawlinewidth;
			state.context.strokeStyle = state.drawlinecolor;
			state.context.lineJoin = "round";
			state.context.lineCap = "round";

			// console.log("move to ", {x: state.x, y: state.y});

			e.preventDefault();
		}
	}

	function SetXY(e) {
		if (e.type == "touchmove") {
			state.x = ((e.touches[0].clientX - state.rect.left) * state.preview.width) / state.rect.width;
			state.y = ((e.touches[0].clientY - state.rect.top) * state.preview.height) / state.rect.height;
		} else if (e.type == "mousemove") {
			state.x = ((e.clientX - state.rect.left) * state.preview.width) / state.rect.width;
			state.y = ((e.clientY - state.rect.top) * state.preview.height) / state.rect.height;
		}
	}

	function continuedraw(e) {
		if (state.drawmode) {
			if (state.isDrawing) {
				SetXY(e);
				state.context.lineTo(state.x, state.y);
				state.context.stroke();
				e.preventDefault();
			}
		}
	}

	function enddraw(e) {
		if (state.drawmode) {
			if (state.isDrawing) {
				continuedraw(e);
				state.context.closePath();
				state.isDrawing = false;
				e.preventDefault();
			}
		}
	}

	// function ContinousActions(action) {
	// 	return {
	// 		ontouchstart: () => {
	// 			console.log("touch start");
	// 			state.KeepChanging = true;
	// 			PerformChange(action);
	// 		},
	// 		ontouchend: () => {
	// 			console.log("touch end");
	// 			state.KeepChanging = false;
	// 		},
	// 		onmousedown: () => {
	// 			console.log("mouse down start");
	// 			state.KeepChanging = true;
	// 			PerformChange(action);
	// 			console.log("started process", {action});
	// 		},
	// 		onmouseup: () => {
	// 			console.log("mouse down end");
	// 			state.KeepChanging = false;
	// 		},
	// 	};
	// }

	function CreateImageEditor() {
		return m(
			".image-editor-overlay.fixed-centered",
			{
				class: state.editmode ? "visible" : "hidden",
			},
			state.imageindex > -1 && [
				state.zoommode
					? m("img", {
							src: state.images[state.imageindex].original,
							style: `display:block;width: 100%; height: 100%;`,
							oncreate: (u) => {
								state.cropperdom = u.dom;
							},
							onload: () => {
								state.cropper = new Cropper(state.cropperdom, {
									// viewMode: 1,
									// aspectRatio: 1,
									checkOrientation: false,
								});
								// console.log({cropper});
							},
							onremove: () => {
								state.cropper.destroy();
								state.cropperdom = undefined;
							},
					  })
					: m("canvas.editor", {
							oncreate: (u) => {
								u.dom.height = state.options.height;
								u.dom.width = state.options.width;
								state.preview = u.dom;
								DrawImage();
							},
							onmousedown: startdraw,
							onmousemove: continuedraw,
							onmouseup: enddraw,
							onmouseout: enddraw,
							onmouseleave: enddraw,
							ontouchstart: startdraw,
							ontouchmove: continuedraw,
							ontouchend: enddraw,
							ontouchcancel: enddraw,
					  }),

				!state.zoommode &&
					!state.drawmode &&
					m(".top-buttons", [
						// m(
						// 	".icon.flipH.flex-grow",
						// 	{
						// 		onclick: () => {
						// 			PerformChange(ChangeOptions.FlipH);
						// 		},
						// 	},
						// 	m(Icon, {
						// 		name: Icons.COLUMNS,
						// 	})
						// ),
						// m(
						// 	".icon.flipV.flex-grow",
						// 	{
						// 		onclick: () => {
						// 			PerformChange(ChangeOptions.FlipV);
						// 		},
						// 	},
						// 	m(Icon, {
						// 		style: "rotate: 90deg;",
						// 		name: Icons.COLUMNS,
						// 	})
						// ),
						m(
							".icon.rotate-ccw.flex-grow",
							{
								onclick: () => {
									PerformChange(ChangeOptions.RotateCCW);
								},
							},
							m(Icon, {
								name: Icons.ROTATE_CCW,
							})
						),
						m(
							".icon.rotate-cw.flex-grow",
							{
								onclick: () => {
									PerformChange(ChangeOptions.RotateCW);
								},
							},
							m(Icon, {
								name: Icons.ROTATE_CW,
							})
						),
					]),
				m(".bottom-buttons", [
					// state.images[state.imageindex]?.changed &&
					// 	m(
					// 		".icon.undo.flex-grow",
					// 		{
					// 			onclick: () => {
					// 				state.drawmode = false;
					// 				state.zoommode = false;
					// 			},
					// 		},
					// 		m(Icon, {
					// 			name: Icons.X_CIRCLE,
					// 		})
					// 	),
					state.zoommode
						? m(
								".icon.save.flex-grow",
								{
									onclick: () => {
										let croppedImg = state.cropper.getCroppedCanvas({fillColor: "white"}).toDataURL("image/jpeg");
										console.log({croppedImg});
										CompressImage(croppedImg).then((newdata) => {
											console.log({newdata});
											state.newurl = newdata;
											state.images[state.imageindex].url = state.newurl;
											state.zoommode = false;
											SaveStateToLocal();
											m.redraw();
										});
									},
								},
								m(Icon, {
									name: Icons.SAVE,
								})
						  )
						: state.drawmode
						? [
								m("input", {
									type: "color",
									value: state.drawlinecolor,
									onchange: (e) => {
										state.drawlinecolor = e.target.value;
										// console.log({color: state.drawlinecolor, e});
									},
									oninput: (e) => {
										state.drawlinecolor = e.target.value;
										// console.log({color: state.drawlinecolor, e});
									},
								}),
								m(
									".icon.save.flex-grow",
									{
										onclick: () => {
											state.images[state.imageindex].url = state.preview.toDataURL("image/jpeg");
											state.drawmode = false;
											SaveStateToLocal();
										},
									},
									m(Icon, {
										name: Icons.SAVE,
									})
								),
								m(
									".brush-size-display",
									m(".brush-stroke", {
										style: `width: ${state.drawlinewidth}px; 
										height: ${state.drawlinewidth}px; 
										background-color: ${state.drawlinecolor};`,
									})
								),
								m("input", {
									type: "range",
									min: 2,
									max: 20,
									style: "width: 100px;",
									step: 1,
									value: state.drawlinewidth,
									onchange: (e) => {
										state.drawlinewidth = e.target.value;
										// console.log({color: state.drawlinecolor, e});
									},
									oninput: (e) => {
										state.drawlinewidth = e.target.value;
										// console.log({color: state.drawlinecolor, e});
									},
								}),
						  ]
						: [
								m(
									".icon.delete-image.flex-grow",
									{
										onclick: () => {
											state.images.splice(state.imageindex, 1);
											state.imageindex = -1;
											state.editmode = false;
											SaveStateToLocal();
										},
									},
									m(Icon, {
										name: Icons.TRASH_2,
									})
								),
								m(
									".icon.draw.flex-grow",
									{
										onclick: () => {
											state.drawmode = true;
											state.images[state.imageindex].changed = true;
										},
									},
									m(Icon, {
										name: Icons.EDIT_3,
									})
								),
								m(
									".icon.crop.flex-grow",
									{
										onclick: () => {
											state.zoommode = true;
											state.images[state.imageindex].changed = true;
										},
									},
									m(Icon, {
										name: Icons.CROP,
									})
								),
								m(
									".icon.final-save.flex-grow",
									{
										onclick: () => {
											state.images[state.imageindex].url = state.preview.toDataURL("image/jpeg");
											state.images[state.imageindex].modifiers = {};
											state.imageindex = -1;
											state.editmode = false;
											SaveStateToLocal();
										},
									},
									m(Icon, {
										name: Icons.SAVE,
									})
								),
								m(
									".icon.final-cancel.flex-grow",
									{
										onclick: () => {
											CompressImage(state.images[state.imageindex].original).then((newv) => {
												state.images[state.imageindex].changed = false;
												state.images[state.imageindex].modifiers = {};
												state.images[state.imageindex].url = newv;
												state.imageindex = -1;
												state.editmode = false;
												state.zoommode = false;
												state.drawmode = false;
												m.redraw();
												SaveStateToLocal();
											});
										},
									},
									m(Icon, {
										name: Icons.ROTATE_CCW,
									})
								),
						  ],
				]),
			]
		);
	}

	function CreateContent() {
		return m(
			".camera-module-outer-wrapper.fixed-centered",
			{
				class: state.editmode ? "hidden" : "visible",
				oncreate: (u) => {
					state.maxwidth = u.dom.getBoundingClientRect().width;
					state.maxheight = u.dom.getBoundingClientRect().height;
				},
			},
			[
				state.errorinfo
					? m(".error-info", state.errorinfo)
					: m(
							".camera-component-wrapper",
							m(".interface", [
								m(".file-upload-area", [
									m(
										"label.add-files.browse",
										m(".icon", m(Icon, {name: Icons.UPLOAD_CLOUD})),
										m("span.button-text", "Browse"),
										m("input.file-upload", {
											type: "file",
											accept: "image/*",
											onchange: OnFileUpload,
											multiple: true,
										})
									),
									m(
										"label.add-files.browse",
										m(".icon", m(Icon, {name: Icons.CAMERA})),
										m("span.button-text", "Camera"),
										m("input.file-upload", {
											type: "file",
											capture: "camera",
											accept: "image/*",
											onchange: OnFileUpload,
										})
									),
								]),
								m(".existing-files.saved"),
								m(".existing-files.unsaved", [
									state.images.map((img, i) => {
										return m(
											".image-wrapper",
											{
												onclick: () => {
													state.imageindex = i;
													state.editmode = true;
													DrawImage();
												},
											},
											[m("img", {src: img.url})]
										);
									}),
								]),
								m(".free-space"),
								m(".action-buttons", [
									state.images.length > 0 && [
										m(
											".final-upload-button",
											m(
												"label.add-files.browse",
												{
													onclick: SaveFiles,
												},
												m(".icon", m(Icon, {name: Icons.SAVE})),
												m("span.button-text", "Save")
											)
										),
										m(
											".final-action-button",
											m(
												"label",
												{
													onclick: ClearFiles,
												},
												m(".icon", m(Icon, {name: Icons.TRASH})),
												m("span.button-text", "Clear")
											)
										),
									],
									m(
										".final-action-button",
										m(
											"label",
											{
												onclick: StopExplorer,
											},
											m(".icon", m(Icon, {name: Icons.X_CIRCLE})),
											m("span.button-text", "Cancel")
										)
									),
								]),
							])
					  ),
			]
		);
	}

	function StartExplorer() {
		SeeIfPendingState().then((images) => {
			if (images) state.images = images;
			state.showexplorer = true;
			m.redraw();
		});
	}
	function StopExplorer() {
		state.showexplorer = false;
	}

	function SaveFiles() {
		// let keys = state.images.map((img, i) => {
		// 	// workermanager.UpdateFile(state.nf, i, img.url);

		// 	return {
		// 		name: pf.RemoveSpecialCharacters(img.name),
		// 		id: i,
		// 		type: "image",
		// 	};
		// });

		// workermanager.UpdateFiles(state.nf, keys, state.links, state.value, (r) => {
		// 	// onchange(r);
		// });

		let newB64s = state.images.map((img) => {
			return {
				caption: pf.RemoveSpecialCharacters(img.name, true),
				url: img.url,
				new: true,
				uuid: ulid(),
				nf: state.nf,
			};
		});

		workermanager.UploadFilesOffline(ulid(), state.nf, newB64s);

		if (state.links) newB64s = [...state.links, ...newB64s];
		// console.log({links: newB64s});
		if (state.onchange) state.onchange(newB64s);

		ClearFiles();
		StopExplorer();
		pf.Inform("Files will be uploaded on the backend. No need to refresh regularly.");
	}

	return {
		oninit: ({attrs: {nf, options, links, value, filetypes, onchange}}) => {
			state.nf = nf;
			state.options = options;
			state.links = links;
			state.value = value;
			state.filetypes = filetypes;
			state.onchange = onchange;

			// resetstatejson = JSON.stringify(state);
			// AskForPermission();
		},
		view: () => {
			// if (state.showexplorer) console.log({state});
			return [
				m(
					"button.camera-module-trigger",
					{
						type: "button",
						onclick: () => {
							StartExplorer();
						},
					},
					// "Image Uploader"
					m(Icon, {name: Icons.UPLOAD_CLOUD})
				),
				m(Overlay, {
					closeOnEscapeKey: true,
					closeOnOutsideClick: true,
					hasBackdrop: true,
					inline: false,
					content: [CreateContent(), CreateImageEditor()],
					isOpen: state.showexplorer,
					onClose: () => {
						StopExplorer();
					},
					transitionDuration: 200,
				}),
				m("canvas.hidden", {
					oncreate: (u) => {
						state.hiddencanvas = u.dom;
						state.hiddencanvas.width = state.options.width;
						state.hiddencanvas.height = state.options.height;
					},
				}),
			];
		},
	};
};
